import { call, fork, race, take, put, takeEvery } from 'redux-saga/effects';
import AxiosFactory from 'utils/axiosFactory';
import { Config, ENVIRONMENT } from 'utils/webappConfig';
import * as budgetItemsActions from 'data/budgetItems/budgetItemsActions';
import * as budgetItemsSelectors from 'data/budgetItems/budgetItemsSelectors';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';
import { getQcsSyncResources, qcsSyncUpdateResources, qcsSyncUpdateResource } from 'data/qcsSyncResourceSagaHelpers';
import { getLogger } from 'utils/logger';
import * as transactionsActions from 'data/transactions/actions';
import * as categoryGroupsActions from 'data/categoryGroups/categoryGroupsActions';
import { getFeatureFlags } from 'utils/featureFlags/selectors';
import store from 'store';

const log = getLogger('data/budgetItems/budgetItemsSagas.js');

const mkResourceConfig = (props) => mkQcsSyncResourceConfig({
  resourceName: 'budgetItems',
  resourceBaseUrl: '/budgets/budget-items',
  getLastSyncDate: budgetItemsSelectors.getLastSyncDate,
  ...props,
});

function* recalcBudgetItems(action) {

  try {
    log.log('recalcBudgetItemsAction: server calculation start...');
    const qcsAxios = AxiosFactory.get('qcs');
    const requestUrl = `${Config.environments[ENVIRONMENT].services_url}/budget-calc`;
    const response = yield call(qcsAxios.get, requestUrl);
    log.log('recalcBudgetItemsAction: server calculation complete...\nresponse = ', response);
  } catch (error) {
    log.log('recalcBudgetItemsAction: server calculation failed...\nerror = ', error);
  }

  const config = mkResourceConfig({
    successAction: budgetItemsActions.getBudgetItemsSuccessAction,
    failureAction: budgetItemsActions.getBudgetItemsFailureAction,
  });
  yield call(getQcsSyncResources, config, action);
}

const getBudgetItemsActionQueue = [];
export function* getBudgetItemsActionWatcher() {
  while (true) {
    const { getBudgetItemsAction, getBudgetItemsSuccessAction, getBudgetItemsFailureAction } = yield race({
      getBudgetItemsAction: take(budgetItemsActions.getBudgetItemsAction),
      getBudgetItemsSuccessAction: take(budgetItemsActions.getBudgetItemsSuccessAction),
      getBudgetItemsFailureAction: take(budgetItemsActions.getBudgetItemsFailureAction),
    });

    let launchAction = false;
    if (getBudgetItemsAction) {
      launchAction = getBudgetItemsActionQueue.length === 0;
      if (getBudgetItemsActionQueue.length < 2) {
        getBudgetItemsActionQueue.push(getBudgetItemsAction);
      }
    } else if (getBudgetItemsSuccessAction || getBudgetItemsFailureAction) {
      getBudgetItemsActionQueue.shift();
      launchAction = getBudgetItemsActionQueue.length > 0;
    }
    if (launchAction) {
      yield fork(recalcBudgetItems, getBudgetItemsActionQueue[0]);
    }
  }
}

export function* updateBudgetItemsActionWatcher(): Generator<*, *, *> {
  const config = mkResourceConfig({
    successAction: budgetItemsActions.updateBudgetItemsSuccessAction,
    failureAction: budgetItemsActions.updateBudgetItemsFailureAction,
  });
  yield takeEvery(budgetItemsActions.updateBudgetItemsAction, qcsSyncUpdateResources, config);
}

function* deleteBudgetItems(config, data) {
  const newData = data;
  newData.payload = data.payload.map((item) => item.set('isDeleted', true));
  return yield call(qcsSyncUpdateResources, config, newData);
}

export function* deleteBudgetItemsActionWatcher() {
  const config = mkResourceConfig({
    successAction: budgetItemsActions.deleteBudgetItemsSuccessAction,
    failureAction: budgetItemsActions.deleteBudgetItemsFailureAction,
  });
  yield takeEvery(budgetItemsActions.deleteBudgetItemsAction, deleteBudgetItems, config);
}

export function* createBudgetItemsActionWatcher(): Generator<*, *, *> {
  const config = mkResourceConfig({
    successAction: budgetItemsActions.createBudgetItemsSuccessAction,
    failureAction: budgetItemsActions.createBudgetItemsFailureAction,
  });
  yield takeEvery(budgetItemsActions.createBudgetItemsAction, qcsSyncUpdateResources, config);
}

export function* updateBudgetItemActionWatcher() {
  const config = mkResourceConfig({
    successAction: budgetItemsActions.updateBudgetItemSuccess,
    failureAction: budgetItemsActions.updateBudgetItemFailure,
  });
  yield takeEvery(budgetItemsActions.updateBudgetItem, qcsSyncUpdateResource, config);
}

function* transactionModified(action) {
  const featureFlags = getFeatureFlags(store.getState());
  if (featureFlags && featureFlags.get('budgets')
    && action && action.meta && action.meta.context && (
    action.meta.context === 'Reg_Budgets'
    || action.meta.context === 'addAccounts'
  )
    && (action.type !== transactionsActions.getTransactionsSuccess.toString() || (action.payload && action.payload.resources && action.payload.resources.length > 0))
  ) {
    yield put(budgetItemsActions.getBudgetItemsAction());
  }
}

function* budgetItemAdded() {
  const featureFlags = getFeatureFlags(store.getState());
  if (featureFlags && featureFlags.get('budgets')) {
    yield put(budgetItemsActions.getBudgetItemsAction());
  }
}

function *checkCategoryGroups(_action) {

  // console.log("CHECK CATEGORY GROUPS FOR BUDGET ITEMS ", action);


}

function* transactionModifiedActionWatcher() {
  yield takeEvery(budgetItemsActions.createBudgetItemsSuccessAction, budgetItemAdded);
  yield takeEvery(transactionsActions.getTransactionsSuccess, transactionModified);
  yield takeEvery(transactionsActions.createTransactionsSuccess, transactionModified);
  yield takeEvery(transactionsActions.updateTransactionsSuccess, transactionModified);
  yield takeEvery(transactionsActions.deleteTransactionsSuccess, transactionModified);
  yield takeEvery(transactionsActions.performTransactionActionSuccess, transactionModified);
  yield takeEvery(categoryGroupsActions.updateCategoryGroupAction, checkCategoryGroups);
}

export default [
  getBudgetItemsActionWatcher,
  updateBudgetItemsActionWatcher,
  updateBudgetItemActionWatcher,
  transactionModifiedActionWatcher,
  deleteBudgetItemsActionWatcher,
  createBudgetItemsActionWatcher];

